import React, { Component } from 'react';
import styled from 'styled-components';
import {
  Box,
  Button,
  Card,
  Flex,
  Heading,
} from 'rebass';
import { MaskInput } from '../components/MaskInput';
import { Formik, Form } from 'formik';
import { FormField } from '../components/FormField';
import { ADMIN_UNREGISTER_KIT_LOCALDB } from '../graphql';
import { compose, withApollo } from 'react-apollo';
import { withToastManager } from 'react-toast-notifications/dist/ToastProvider';

const Container = styled(Box)`
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  padding-top: 48px;
`;

class UnregisterKitLocalDb extends Component {
  handleSubmit = async (values, actions) => {
    actions.setSubmitting(true);

    try {
      const res = await this.props.client.mutate({
        mutation: ADMIN_UNREGISTER_KIT_LOCALDB,
        variables: {
          serial: values.serial,
        },
      });
      
      if (res && res.data && res.data.adminUnregisterKitLocalDb) {
        if (res.data.adminUnregisterKitLocalDb.ok === true) {
          actions.resetForm();
          this.props.toastManager.add('Updated successfully', {
            appearance: 'success',
          });
        } else {
          this.props.toastManager.add(
            res.data.adminUnregisterKitLocalDb.customError.userMessage ||
              'Error updating',
            { appearance: 'error' }
          );
          console.log(
            'Unable to update email: ',
            res.data.adminUnregisterKitLocalDb.customError.errorMessage
          );
        }
      } else {
        actions.setSubmitting(false);
        this.props.toastManager.add('Error updating, please try again', {
          appearance: 'error',
        });
      }

      actions.setSubmitting(false);
      //   toastManager.add('Error submitting intake form', { appearance: 'error' });
    } catch (err) {
      console.log('ADMIN_UNREGISTER_KIT_LOCALDB Err', err);
      actions.setSubmitting(false);
      this.props.toastManager.add('Error updating, please try again', {
        appearance: 'error',
      });
    }
  };
  
  render() {
    return (
      <Container>
        <Flex m={[3, 5]} flex={1} flexDirection="column">
          <Heading mb={4} mt={[3, 0]} ml={[1, 0]} fontSize={[4, 5]}>
            Unregister Kit
          </Heading>
          <Card mb={4} p={[3, 4]}>
            <Flex flexDirection={'column'} flex={1} alignItems="center">
              <Formik
                initialValues={{ oldemail: '', newemail: '' }}
                // validationSchema={schema}
                onSubmit={(values, actions) =>
                  this.handleSubmit(values, actions)
                }
                render={({
                  errors,
                  touched,
                  isValid,
                  isSubmitting,
                  handleChange,
                  handleBlur,
                  values,
                }) => (
                  <Form style={{ width: '300px' }}>
                    <Flex flexDirection="column" flex={1}>
                      <Heading mb={4}>Kit Serial</Heading>
                    </Flex>
                    <FormField mb={4} error={touched.serial && errors.serial}>
                      <MaskInput
                        mask="***-***-***"
                        value={values.serial}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{
                          marginBottom: '16px',
                          textAlign: 'center',
                          letterSpacing: '4px',
                        }}
                        type="serial"
                        name="serial"
                      />
                    </FormField>

                    <Button
                      mt={4}
                      mb={4}
                      variant="primary"
                      width={1 / 2}
                      disabled={!isValid || isSubmitting}
                      type="submit"
                    >
                      Change
                    </Button>
                  </Form>
                )}
              />
            </Flex>
          </Card>
        </Flex>
      </Container>
    );
  }
}

export default compose(
  withApollo,
  withToastManager
)(UnregisterKitLocalDb);
